import type { RichTextSection as RichTextSectionType } from '@shared/lib/page-sections/types';
import { sanitizeCmsHtml } from '@/lib/sanitize-html';

const WIDTH: Record<NonNullable<RichTextSectionType['width']>, string> = {
  narrow: 'max-w-2xl',
  normal: 'max-w-3xl',
  wide: 'max-w-5xl',
};

const ALIGN: Record<NonNullable<RichTextSectionType['align']>, string> = {
  left: 'text-left',
  center: 'text-center',
};

export default function RichTextSection({ section }: { section: RichTextSectionType }) {
  const widthClass = WIDTH[section.width ?? 'normal'];
  const alignClass = ALIGN[section.align ?? 'left'];

  return (
    <section className="w-full px-4 py-10 md:py-14">
      <div className={`prose prose-slate mx-auto ${widthClass} ${alignClass}`}>
        <div dangerouslySetInnerHTML={{ __html: sanitizeCmsHtml(section.html) }} />
      </div>
    </section>
  );
}
